import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  Container,
  ModalContainer,
  KeyboardView
} from "app/NativeComponents/common";
import { Header } from "app/NativeComponents/snippets";

import {
  appRedirect,
  toggleModal,
  setModal,
  getTeamFilters,
  updateList,
  buildList,
  setActiveList,
  setFilters,
  setFeatureModal,
  getLists,
  checkIfUserHasModule,
  checkIfFilterChanged,
  renderPrice,
  numberWithCommas,
  getBilling,
  setPricingPage,
  togglePricingPage
} from "app/NativeActions";

import SelectLocationType from "./SelectLocationType";
import SelectFilters from "./SelectFilters";
import NameList from "./NameList";
import SelectSmartList from "./SelectSmartList";
import StartMarketing from "./StartMarketing";
import Buttons from "./Buttons";
import Count from "./Count";

import OnboardingContainer from "app/DealMachineCore/snippets/OnboardingContainer";

class BuildList extends Component {
  constructor(props) {
    super(props);
    const plan_module_info = checkIfUserHasModule({
      plan_modules: props.plan_modules,
      user: props.user,
      slug: "lists"
    });
    this.state = {
      plan_module_info: plan_module_info,
      route_plan: props.navigation
        ? props.navigation.state.params.route_plan
        : null,
      location_type: "zip",
      route_plan_type: "",
      preset: -1,
      preset_object: null,
      zip: "",
      city: "",
      state: "",
      drawing_coordinates: [],
      location_success: false,
      preset_success: false,
      list_name: "",
      name_success: false,
      smart_success: true,
      smart_list: 0,
      start_marketing: 0,
      total_leads_estimated: 0,
      over_limit: false
    };

    this.startBuilding = this.startBuilding.bind(this);
    this.editListBuilderField = this.editListBuilderField.bind(this);
    this.switchLocationType = this.switchLocationType.bind(this);
    this.routePlanSwitcher = this.routePlanSwitcher.bind(this);
    this.switchPreset = this.switchPreset.bind(this);
    this.handleModalPress = this.handleModalPress.bind(this);
  }

  switchLocationType(location_type) {
    this.setState({ location_type });
  }

  routePlanSwitcher(route_plan_type) {
    this.setState({ route_plan_type });
  }

  switchPreset({ preset, preset_object }) {
    this.setState({ preset: preset, preset_object: preset_object });
  }

  editListBuilderField({ prop, value }) {
    this.setState({ [prop]: value });
  }

  componentDidMount() {
    this.props.setActiveList("build");

    if (this.state.route_plan) {
      this.props.getLists({
        token: this.props.token,
        load_type: this.state.route_plan ? false : "refresh",
        begin: 0
      });
    } else {
      this.props.getBilling({
        token: this.props.token,
        type: "lists_info_banner"
      });
    }

    if (this.props.user.team_clearance_level == 0 && !this.state.route_plan) {
      this.handleBack();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.team_filters !== this.props.team_filters) {
      if (this.props.team_filters) {
        for (let i = 0; i < this.props.team_filters.length; i++) {
          if (this.state.preset == this.props.team_filters[i].id) {
            this.switchPreset({
              preset: this.props.team_filters[i].id,
              preset_object: this.props.team_filters[i]
            });
            this.props.setFilters(this.props.team_filters[i].filter_json);
          }
        }
      }
    } else {
      if (
        (this.state.preset !== prevState.preset ||
          this.state.preset_object !== prevState.preset_object) &&
        this.state.preset !== null
      ) {
        this.props.setFilters(this.state.preset_object.filter_json);
      } else if (
        this.state.preset !== null &&
        this.state.preset_object !== null &&
        prevState.preset !== null &&
        checkIfFilterChanged(this.props.filters, prevProps.filters)
      ) {
        if (
          checkIfFilterChanged(
            {
              ...this.props.original_filters,
              ...this.state.preset_object.filter_json
            },
            this.props.filters
          )
        ) {
          this.switchPreset({ preset: null, preset_object: null });
        }
      } else if (
        prevProps.filters &&
        checkIfFilterChanged(this.props.filters, prevProps.filters)
      ) {
        this.switchPreset({ preset: null, preset_object: null });
      }
    }

    if (prevProps.user && prevProps.plan_modules) {
      if (
        this.props.plan_modules !== prevProps.plan_modules ||
        this.props.user.plan_modules !== prevProps.user.plan_modules
      ) {
        const plan_module_info = checkIfUserHasModule({
          plan_modules: this.props.plan_modules,
          user: this.props.user,
          slug: "lists"
        });
        this.setState({ plan_module_info: plan_module_info });
        this.props.getLists({
          token: this.props.token,
          no_count: true,
          load_type: this.state.route_plan ? false : "refresh",
          begin: 0
        });
      }
    }
    if (prevProps.get_list_count != this.props.get_list_count) {
      this.setState({
        total_leads_estimated:
          parseInt(this.props.total_lead_count) +
          parseInt(this.props.get_list_count)
      });
    }
    if (
      prevState.total_leads_estimated != this.state.total_leads_estimated &&
      this.state.total_leads_estimated > this.props.current_lead_limit
    ) {
      this.setState({ over_limit: true });
    }
  }

  handleBack() {
    this.props.setActiveList(null);
    this.props.appRedirect({
      redirect: "goBack",
      payload: { remove: "build-list" }
    });
  }

  handleModalPress() {
    const { token, get_list_count, filters } = this.props;
    const {
      list_name,
      smart_list,
      start_marketing,
      preset,
      preset_object,
      location_type,
      zip,
      city,
      state,
      drawing_coordinates
    } = this.state;

    this.props.buildList({
      token: this.props.token,
      title: list_name,
      list_type: "build_list",
      smart_list,
      start_marketing,
      list_preset: preset > 0 ? preset : null,
      list_filters:
        preset == null || preset_object == null
          ? filters
          : preset_object.filter_json,
      list_area_type: location_type,
      list_area:
        location_type == "zip" ? zip : location_type == "city" ? city : "",
      list_area_2: location_type == "city" ? state : "",
      list_geo_fence: location_type == "draw" ? drawing_coordinates : [],
      estimated_count: get_list_count && get_list_count > 0 ? get_list_count : 0
    });
  }

  checkIfOverLimit(continueToBuild = () => {}) {
    const { get_list_count, pricing, current_lead_limit } = this.props;

    if (this.state.over_limit) {
      this.props.setModal({
        title: "Over CRM Lead Limit",
        description:
          "Your CRM account only has room for " +
          numberWithCommas(current_lead_limit) +
          " leads. You will be charged $50.00 for every 50,000 leads over the limit.",
        icon: "",
        submit: "Build List",
        onPress: () => {
          continueToBuild();
        },
        cancel: "Nevermind. Cancel Action.",
        onCancel: () => {}
      });
      this.props.toggleModal({ show: true, type: "normal" });
    } else {
      continueToBuild();
    }
  }

  startBuilding() {
    const { get_list_count, pricing } = this.props;
    const { start_marketing, smart_list } = this.state;

    this.checkIfOverLimit(() => {
      if (start_marketing == 1 && smart_list == 1 && get_list_count > 1) {
        this.props.setModal({
          title:
            "Are you sure you want to start mailers/campaigns for " +
            numberWithCommas(get_list_count) +
            " leads added from this list?",
          description:
            "By starting mailers/campaigns, you'll be starting the mailing sequence for all " +
            numberWithCommas(get_list_count) +
            " leads added from this list. You'll be using " +
            renderPrice(pricing.mailer_price * get_list_count) +
            " of your DealCredit. You will be charged for more credit if you don't have enough. You cannot undo this. Mailers will be sent to the queue within the hour.",
          icon: "",
          submit: "Build List",
          onPress: this.handleModalPress,
          cancel: "Nevermind. Cancel Action.",
          onCancel: () => {}
        });
        this.props.toggleModal({ show: true, type: "normal" });
      } else {
        this.handleModalPress();
      }
    });
  }

  render() {
    /*
    if (
      (!this.state.plan_module_info.has_module ||
        this.props.card_info.bad_card == 1) &&
      !this.state.route_plan
    ) {
      return (
        <OnboardingContainer
          slug="lists"
          contentful_slug="lists"
          title={"Build Lists"}
          plan_module_info={this.state.plan_module_info}
          leftButtonIcon={this.props.isMobile ? "arrow-back" : "close"}
          leftButtonAction={() => this.handleBack()}
        />
      );
    }
    */

    return (
      <Wrapper style={{ flex: 1 }}>
        <Container includeInfoBanner={"lists_info_banner"}>
          <Header
            title={this.state.route_plan ? "Plan Your Route" : "Build List"}
            leftButtonIcon={this.props.isMobile ? "arrow-back" : "close"}
            leftButtonAction={() => {
              this.handleBack();
            }}
          />
          <KeyboardView>
            <Wrapper
              style={{
                padding: this.props.isMobile ? 0 : 20,
                paddingBottom: 100
              }}
            >
              <SelectLocationType
                {...this.props}
                location_type={this.state.location_type}
                route_plan_type={this.state.route_plan_type}
                zip={this.state.zip}
                city={this.state.city}
                state={this.state.state}
                drawing_coordinates={this.state.drawing_coordinates}
                switchLocationType={this.switchLocationType}
                routePlanSwitcher={this.routePlanSwitcher}
                editListBuilderField={this.editListBuilderField}
                route_plan={this.state.route_plan}
              />

              <SelectFilters
                {...this.props}
                preset={this.state.preset}
                preset_object={this.state.preset_object}
                location_success={this.state.location_success}
                switchPreset={this.switchPreset}
                editListBuilderField={this.editListBuilderField}
                plan_module_info={this.state.plan_module_info}
                route_plan={this.state.route_plan}
              />

              <NameList
                {...this.props}
                location_type={this.state.location_type}
                preset={this.state.preset}
                preset_object={this.state.preset_object}
                list_name={this.state.list_name}
                zip={this.state.zip}
                city={this.state.city}
                state={this.state.state}
                location_success={this.state.location_success}
                preset_success={this.state.preset_success}
                editListBuilderField={this.editListBuilderField}
                route_plan={this.state.route_plan}
              />

              <SelectSmartList
                {...this.props}
                plan_module_info={this.state.plan_module_info}
                smart_list={this.state.smart_list}
                location_success={this.state.location_success}
                preset_success={this.state.preset_success}
                name_success={this.state.name_success}
                editListBuilderField={this.editListBuilderField}
                route_plan={this.state.route_plan}
              />
              <StartMarketing
                {...this.props}
                plan_module_info={this.state.plan_module_info}
                smart_list={this.state.smart_list}
                start_marketing={this.state.start_marketing}
                location_success={this.state.location_success}
                preset_success={this.state.preset_success}
                name_success={this.state.name_success}
                editListBuilderField={this.editListBuilderField}
                route_plan={this.state.route_plan}
              />
              <Buttons
                {...this.props}
                location_type={this.state.location_type}
                preset={this.state.preset}
                preset_object={this.state.preset_object}
                list_name={this.state.list_name}
                zip={this.state.zip}
                city={this.state.city}
                state={this.state.state}
                drawing_coordinates={this.state.drawing_coordinates}
                location_success={this.state.location_success}
                preset_success={this.state.preset_success}
                name_success={this.state.name_success}
                smart_success={this.state.smart_success}
                startBuilding={this.startBuilding}
                route_plan={this.state.route_plan}
              />
            </Wrapper>
          </KeyboardView>
        </Container>
        <Count
          {...this.props}
          location_type={this.state.location_type}
          preset={this.state.preset}
          preset_object={this.state.preset_object}
          list_name={this.state.list_name}
          zip={this.state.zip}
          city={this.state.city}
          state={this.state.state}
          drawing_coordinates={this.state.drawing_coordinates}
          location_success={this.state.location_success}
          preset_success={this.state.preset_success}
          name_success={this.state.name_success}
          smart_success={this.state.smart_success}
          startBuilding={this.startBuilding}
          route_plan={this.state.route_plan}
        />
      </Wrapper>
    );
  }
}

const mapStateToProps = ({ auth, native, settings, billing, filter, list }) => {
  const { token, user } = auth;
  const {
    device,
    platform,
    isMobile,
    isIphoneX,
    mobile_toggle_drawer
  } = native;
  const { states, colors } = settings;
  const {
    plan_modules,
    card_info,
    pricing,
    current_lead_limit,
    total_lead_count,
    lists_info_banner
  } = billing;

  const { team_filters, filters, original_filters } = filter;
  const {
    get_list_count,
    get_list_count_loading,
    lists_limits,
    lists_refreshing
  } = list;

  return {
    token,
    user,
    device,
    platform,
    isMobile,
    isIphoneX,
    mobile_toggle_drawer,
    colors,
    plan_modules,
    team_filters,
    card_info,
    pricing,
    states,
    filters,
    original_filters,
    get_list_count,
    get_list_count_loading,
    current_lead_limit,
    total_lead_count,
    lists_limits,
    lists_info_banner
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  toggleModal,
  setModal,
  updateList,
  buildList,
  getTeamFilters,
  setActiveList,
  setFilters,
  setFeatureModal,
  getLists,
  numberWithCommas,
  getBilling,
  setPricingPage,
  togglePricingPage
})(BuildList);
